export class MailsEcheancierParams {
  /* Available values : AssignedToMe, RequestedByMe, AssignedToMyTeam */
  typeAction?: string;
  actionsEnCoursOnly?: boolean;
  nePasInclurePourInformation?: boolean;
  userIds?: number[];
  dtTransMin?: string;
  DtTransMax?: string;
  DtTraitMin?: string;
  DtTraitMax?: string;

  /* Calculate total items count and return the value in response, the default value: true */
  calcTotal?: boolean;

  /* Search Action where Action Texte is matching totally */
  action?: string;

  sortFields?: string;
  sortOrder?: string;
  pageNumber?: number;
  pageSize?: number;
}
